// pages/Landing.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const Landing = () => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate("/register");
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className="landing-container">
      <style jsx>{`
        /* Reset & Base Styles */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .landing-container {
          min-height: 100vh;
          background: linear-gradient(
            180deg,
            #0c1a3e 0%,
            #1a2c5a 30%,
            #2a3e7a 100%
          );
          font-family: "Montserrat", "Segoe UI", "Roboto", sans-serif;
          color: #ffffff;
          position: relative;
          overflow-x: hidden;
        }

        /* Background Elements */
        .landing-container::before {
          content: "";
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image:
            radial-gradient(
              circle at 15% 50%,
              rgba(255, 215, 0, 0.03) 0%,
              transparent 25%
            ),
            radial-gradient(
              circle at 85% 30%,
              rgba(0, 150, 255, 0.03) 0%,
              transparent 25%
            ),
            radial-gradient(
              circle at 50% 80%,
              rgba(255, 69, 0, 0.02) 0%,
              transparent 20%
            );
          z-index: 0;
        }

        /* Main Content Container */
        .main-content {
          position: relative;
          z-index: 1;
          max-width: 1200px;
          margin: 0 auto;
          padding: 40px 20px;
        }

        /* Welcome Section - Layout matching the image */
        .welcome-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 60px 0;
          animation: fadeIn 1s ease-out;
        }

        .welcome-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 60px;
          max-width: 1000px;
          width: 100%;
        }

        /* Title Section */
        .title-section {
          text-align: center;
          width: 100%;
        }

        .title-sequence {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
          margin-bottom: 40px;
        }

        /* WELCOME text */
        .welcome-text {
          font-family: "Montserrat", sans-serif;
          font-size: 32px;
          font-weight: 600;
          letter-spacing: 12px;
          color: #ffd700;
          text-transform: uppercase;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          margin-bottom: 40px;
          position: relative;
          padding: 0 20px;
        }

        .welcome-text::before,
        .welcome-text::after {
          content: "";
          position: absolute;
          top: 50%;
          width: 40px;
          height: 1px;
          background: linear-gradient(90deg, transparent, #ffd700, transparent);
        }

        .welcome-text::before {
          left: -60px;
        }

        .welcome-text::after {
          right: -60px;
        }

        /* Main titles container */
        .main-titles {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0;
          width: 100%;
        }

        /* "TO" text */
        .main-title {
          font-family: "Playfair Display", serif;
          font-size: 72px;
          font-weight: 800;
          color: #ffffff;
          text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
          margin: 0;
          line-height: 1;
          letter-spacing: 2px;
        }

        /* "TINUBU-AMBODE" text - FIXED */
        .subtitle {
          font-family: "Playfair Display", serif;
          font-size: 70px;
          font-weight: 900;
          color: #ffd700;
          text-shadow:
            0 4px 8px rgba(0, 0, 0, 0.4),
            0 0 30px rgba(255, 215, 0, 0.3);
          margin: 10px 0;
          line-height: 1.1;
          letter-spacing: 1px;
          position: relative;
          display: inline-block;
          text-align: center;
          max-width: 100%;
          padding: 0 10px;
          word-break: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
        }

        .subtitle::before {
          content: "";
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -10px;
          width: 80%;
          min-width: 300px;
          height: 3px;
          background: linear-gradient(
            90deg,
            transparent 0%,
            #ffd700 20%,
            #ffd700 80%,
            transparent 100%
          );
          border-radius: 2px;
        }

        /* "SUPPORTERS PORTAL" text */
        .supporters-text {
          font-family: "Montserrat", sans-serif;
          font-size: 42px;
          font-weight: 700;
          color: #4fc3f7;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          margin-top: 20px;
          letter-spacing: 8px;
          text-transform: uppercase;
          position: relative;
          padding: 10px 40px;
          max-width: 100%;
          overflow-wrap: break-word;
          word-wrap: break-word;
        }

        .supporters-text::before,
        .supporters-text::after {
          content: "✦";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          color: #ffd700;
          font-size: 20px;
        }

        .supporters-text::before {
          left: 0;
        }

        .supporters-text::after {
          right: 0;
        }

        /* Image Section */
        .welcome-image-section {
          width: 100%;
          max-width: 800px;
          margin: 0 auto;
        }

        .welcome-image-display {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          box-shadow:
            0 20px 60px rgba(0, 0, 0, 0.5),
            0 0 0 1px rgba(255, 215, 0, 0.2);
          border: 2px solid rgba(255, 215, 0, 0.3);
          transform: perspective(1200px) rotateX(2deg) rotateY(-3deg);
          transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .welcome-image-display:hover {
          transform: perspective(1200px) rotateX(0) rotateY(0);
          box-shadow:
            0 25px 80px rgba(0, 0, 0, 0.6),
            0 0 0 2px rgba(255, 215, 0, 0.4);
        }

        .image-frame {
          position: relative;
          padding-top: 60%;
          overflow: hidden;
        }

        .welcome-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(1.05) contrast(1.1);
          transition: transform 0.8s ease;
        }

        .welcome-image-display:hover .welcome-image {
          transform: scale(1.03);
        }

        .image-caption {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(
            to top,
            rgba(12, 26, 62, 0.95) 0%,
            rgba(12, 26, 62, 0.7) 50%,
            transparent 100%
          );
          padding: 30px 40px;
          text-align: center;
        }

        .caption-text {
          font-family: "Montserrat", sans-serif;
          font-size: 24px;
          font-weight: 600;
          color: #ffd700;
          letter-spacing: 4px;
          text-transform: uppercase;
          position: relative;
          display: inline-block;
          padding: 0 20px;
        }

        .caption-text::before,
        .caption-text::after {
          content: "★";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          color: #4fc3f7;
          font-size: 14px;
        }

        .caption-text::before {
          left: -10px;
        }

        .caption-text::after {
          right: -10px;
        }

        /* Write-up Section */
        .writeup-section {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 60px 50px;
          margin: 80px 0;
          border: 1px solid rgba(255, 215, 0, 0.15);
          position: relative;
          overflow: hidden;
          animation: slideUp 0.8s ease-out 0.3s both;
        }

        .writeup-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(
            90deg,
            transparent 0%,
            #ffd700 20%,
            #4fc3f7 50%,
            #ffd700 80%,
            transparent 100%
          );
        }

        .writeup-container {
          max-width: 900px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .writeup-title {
          font-family: "Playfair Display", serif;
          font-size: 42px;
          font-weight: 700;
          text-align: center;
          margin-bottom: 40px;
          color: #ffd700;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          position: relative;
          padding-bottom: 20px;
        }

        .writeup-title::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 150px;
          height: 3px;
          background: linear-gradient(90deg, #4fc3f7, #ffd700);
          border-radius: 2px;
        }

        .writeup-subtitle {
          font-family: "Montserrat", sans-serif;
          font-size: 20px;
          line-height: 1.7;
          text-align: center;
          margin-bottom: 60px;
          color: rgba(255, 255, 255, 0.95);
          font-weight: 400;
          padding: 0 20px;
        }

        /* Features Grid */
        .features-list {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
          margin-bottom: 60px;
        }

        .feature-item {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          padding: 30px;
          background: linear-gradient(
            145deg,
            rgba(255, 255, 255, 0.05) 0%,
            rgba(255, 255, 255, 0.02) 100%
          );
          border-radius: 16px;
          border: 1px solid rgba(255, 215, 0, 0.1);
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          position: relative;
          overflow: hidden;
        }

        .feature-item:hover {
          transform: translateY(-8px);
          border-color: rgba(255, 215, 0, 0.3);
          box-shadow:
            0 15px 35px rgba(0, 0, 0, 0.3),
            0 0 0 1px rgba(255, 215, 0, 0.2);
        }

        .feature-item::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            135deg,
            rgba(255, 215, 0, 0.05) 0%,
            rgba(79, 195, 247, 0.05) 100%
          );
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .feature-item:hover::before {
          opacity: 1;
        }

        .feature-icon {
          min-width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #ffd700, #ffa500);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: #0c1a3e;
          font-size: 24px;
          position: relative;
          z-index: 1;
          box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
        }

        .feature-text {
          font-family: "Montserrat", sans-serif;
          font-size: 17px;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 400;
          position: relative;
          z-index: 1;
        }

        /* Commitment Section */
        .commitment-section {
          text-align: center;
          padding: 50px;
          background: linear-gradient(
            135deg,
            rgba(255, 215, 0, 0.1) 0%,
            rgba(79, 195, 247, 0.1) 100%
          );
          border-radius: 20px;
          border: 1px solid rgba(255, 215, 0, 0.2);
          position: relative;
          overflow: hidden;
        }

        .vision-text {
          font-family: "Playfair Display", serif;
          font-size: 28px;
          font-weight: 600;
          color: #ffffff;
          font-style: italic;
          position: relative;
          display: inline-block;
          padding: 0 40px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }

        .vision-text::before,
        .vision-text::after {
          content: '"';
          font-family: "Playfair Display", serif;
          font-size: 60px;
          color: #ffd700;
          position: absolute;
          top: -10px;
          opacity: 0.8;
        }

        .vision-text::before {
          left: 0;
        }

        .vision-text::after {
          right: 0;
        }

        /* Action Buttons Section */
        .action-section {
          text-align: center;
          padding: 60px 0;
          animation: fadeIn 1s ease-out 0.6s both;
        }

        .action-buttons {
          display: flex;
          justify-content: center;
          gap: 40px;
          flex-wrap: wrap;
        }

        .btn {
          padding: 22px 60px;
          font-family: "Montserrat", sans-serif;
          font-size: 18px;
          font-weight: 700;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          text-transform: uppercase;
          letter-spacing: 2px;
          min-width: 240px;
          position: relative;
          overflow: hidden;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        }

        .btn::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transition: 0.6s;
        }

        .btn:hover::before {
          left: 100%;
        }

        .primary-btn {
          background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
          color: #0c1a3e;
          box-shadow: 0 8px 25px rgba(255, 215, 0, 0.4);
        }

        .primary-btn:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 15px 35px rgba(255, 215, 0, 0.6);
        }

        .secondary-btn {
          background: linear-gradient(135deg, #4fc3f7 0%, #2196f3 100%);
          color: #ffffff;
          box-shadow: 0 8px 25px rgba(79, 195, 247, 0.4);
        }

        .secondary-btn:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 15px 35px rgba(79, 195, 247, 0.6);
        }

        /* Animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Responsive Design - IMPROVED */
        @media (max-width: 1200px) {
          .main-title {
            font-size: 64px;
          }
          
          .subtitle {
            font-size: 60px;
          }
          
          .supporters-text {
            font-size: 36px;
            letter-spacing: 6px;
          }
        }

        @media (max-width: 992px) {
          .main-title {
            font-size: 56px;
          }
          
          .subtitle {
            font-size: 52px;
            letter-spacing: 0.5px;
          }
          
          .supporters-text {
            font-size: 32px;
            letter-spacing: 5px;
            padding: 10px 30px;
          }
          
          .features-list {
            gap: 25px;
          }
          
          .feature-item {
            padding: 25px;
          }
        }

        @media (max-width: 768px) {
          .main-content {
            padding: 30px 15px;
          }

          .welcome-text {
            font-size: 24px;
            letter-spacing: 8px;
            margin-bottom: 30px;
          }

          .main-title {
            font-size: 48px;
          }

          .subtitle {
            font-size: 44px;
            letter-spacing: 0.3px;
            word-break: break-word;
          }

          .supporters-text {
            font-size: 28px;
            letter-spacing: 4px;
            padding: 10px 25px;
          }

          .writeup-section {
            padding: 40px 30px;
            margin: 60px 0;
          }

          .writeup-title {
            font-size: 32px;
          }

          .writeup-subtitle {
            font-size: 18px;
            padding: 0;
          }

          .features-list {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .feature-item {
            padding: 20px;
          }

          .action-buttons {
            flex-direction: column;
            align-items: center;
            gap: 25px;
          }

          .btn {
            width: 100%;
            max-width: 320px;
            padding: 20px 40px;
          }

          .vision-text {
            font-size: 24px;
            padding: 0 30px;
          }
          
          .welcome-text::before,
          .welcome-text::after {
            width: 20px;
          }
          
          .welcome-text::before {
            left: -40px;
          }
          
          .welcome-text::after {
            right: -40px;
          }
        }

        @media (max-width: 576px) {
          .main-title {
            font-size: 40px;
          }
          
          .subtitle {
            font-size: 36px;
            letter-spacing: 0.2px;
          }
          
          .supporters-text {
            font-size: 24px;
            letter-spacing: 3px;
            padding: 10px 20px;
          }
          
          .writeup-title {
            font-size: 28px;
          }
          
          .writeup-subtitle {
            font-size: 16px;
          }
        }

        @media (max-width: 480px) {
          .welcome-text {
            font-size: 20px;
            letter-spacing: 5px;
            padding: 0 10px;
          }

          .main-title {
            font-size: 36px;
          }

          .subtitle {
            font-size: 32px;
            padding: 0 5px;
          }

          .supporters-text {
            font-size: 22px;
            letter-spacing: 2px;
            padding: 10px 15px;
          }

          .supporters-text::before,
          .supporters-text::after {
            font-size: 16px;
          }

          .writeup-title {
            font-size: 26px;
          }

          .writeup-subtitle {
            font-size: 16px;
          }

          .feature-icon {
            min-width: 40px;
            height: 40px;
            font-size: 20px;
          }

          .feature-text {
            font-size: 15px;
          }

          .btn {
            padding: 18px 30px;
            font-size: 16px;
          }

          .vision-text {
            font-size: 20px;
            padding: 0 20px;
          }

          .vision-text::before,
          .vision-text::after {
            font-size: 40px;
          }
          
          .caption-text {
            font-size: 20px;
            letter-spacing: 3px;
            padding: 0 15px;
          }
        }
        
        @media (max-width: 380px) {
          .main-title {
            font-size: 32px;
          }
          
          .subtitle {
            font-size: 28px;
          }
          
          .supporters-text {
            font-size: 20px;
            letter-spacing: 1.5px;
          }
          
          .welcome-text {
            font-size: 18px;
            letter-spacing: 4px;
          }
        }

        /* Accessibility */
        @media (prefers-reduced-motion: reduce) {
          .welcome-image-display,
          .feature-item,
          .btn,
          .vision-text {
            transition: none;
            animation: none;
          }
        }

        .btn:focus {
          outline: 3px solid #ffd700;
          outline-offset: 3px;
        }

        /* Loading States */
        .landing-container.loading * {
          animation-play-state: paused !important;
        }
      `}</style>

      <main className="main-content">
        {/* Welcome Section */}
        <div className="welcome-section">
          <div className="welcome-container">
            {/* Title Section */}
            <div className="title-section">
              <div className="title-sequence">
                <h1 className="welcome-text">WELCOME</h1>
                <div className="main-titles">
                  <h1 className="main-title">TO</h1>
                  <h1 className="subtitle">TINUBU-AMBODE</h1>
                  <h1 className="supporters-text">SUPPORTERS PORTAL</h1>
                </div>
              </div>
            </div>

            {/* Welcome Image */}
            <div className="welcome-image-section">
              <div className="welcome-image-display">
                <div className="image-frame">
                  <img
                    src="assets/image.jpg"
                    alt="Tinubu and Ambode - Visionary Leadership"
                    className="welcome-image"
                    loading="lazy"
                  />
                </div>
                <div className="image-caption">
                  <span className="caption-text">Visionary Leadership</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Write-up Section */}
        <div className="writeup-section">
          <div className="writeup-container">
            <h2 className="writeup-title">
              Join the Tinubu–Ambode Movement Today
            </h2>

            <div className="writeup-content">
              <p className="writeup-subtitle">
                Register or log in to show your support and be part of a united
                front for progress and greatness.
              </p>

              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">
                    Registration is free, fast, and secure, with your privacy
                    fully protected
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">
                    Receive real-time updates, news, and notifications via SMS
                    and WhatsApp
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">
                    Connect directly with other supporters for collaboration and
                    discussion
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">
                    Stay informed, connected, and committed to our shared vision
                  </div>
                </div>
              </div>

              <div className="commitment-section">
                <p className="vision-text">
                  Together, we'll make the Tinubu–Ambode vision a reality.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-section">
          <div className="action-buttons">
            <button
              className="btn primary-btn"
              onClick={handleLoginClick}
              aria-label="Sign in to your account"
            >
              Sign In
            </button>
            <button
              className="btn secondary-btn"
              onClick={handleRegisterClick}
              aria-label="Register new account"
            >
              Register Now
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Landing;